(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('cf-collection-scroll')) {
    customElements.define('cf-collection-scroll', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => this.initialize());
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
      }

      initialize() {
        if (!this.isConnected || this.initialized) return;
        this.initialized = true;
        this.grid = this.closest('#ProductGridContainer')?.querySelector('#product-grid');
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.nextUrl = this.dataset.nextUrl;
        this.page = Number(this.dataset.currentPage);
        this.pagesLoaded = new Set();
        if (!this.grid || !this.button || !this.status || !this.nextUrl) return;
        this.setAttribute('data-enhanced', '');
        this.button.hidden = false;
        this.button.addEventListener('click', () => this.loadMore());
        this.updateCount();
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.loadMore();
          }, { rootMargin: '600px 0px' });
          this.observer.observe(this);
        }
      }

      updateCount() {
        this.status.textContent = this.dataset.countLabel
          .replace('__shown__', this.grid.children.length)
          .replace('__total__', this.dataset.total);
      }

      async loadMore() {
        const collection = this.closest('.collection');
        if (this.loading || !this.nextUrl || !this.isConnected || collection?.classList.contains('loading')) return;
        const url = new URL(this.nextUrl, window.location.href);
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
        url.searchParams.set('section_id', this.dataset.sectionId);
        const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        if (this.pagesLoaded.has(url.href)) return;
        this.loading = true;
        this.observer?.unobserve(this);
        this.controller = new AbortController();
        this.button.disabled = true;
        this.setAttribute('aria-busy', 'true');
        this.removeAttribute('data-failed');
        this.status.textContent = this.dataset.loadingLabel;
        let succeeded = false;
        try {
          const response = await fetch(url.href, { signal: this.controller.signal });
          if (!response.ok) throw new Error('Collection page unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!this.isConnected || collection?.classList.contains('loading')) return;
          const nextGrid = html.getElementById('product-grid');
          const nextPager = html.querySelector('cf-collection-scroll');
          if (!nextGrid || !nextPager || nextPager.dataset.sectionId !== this.dataset.sectionId ||
              Number(nextPager.dataset.currentPage) !== this.page + 1) {
            throw new Error('Unexpected collection page');
          }
          const ids = new Set(Array.from(this.grid.children, (item) => item.dataset.productId));
          const items = Array.from(nextGrid.children).filter((item) => item.dataset.productId && !ids.has(item.dataset.productId));
          if (!items.length) throw new Error('No additional products returned');
          for (const item of items) {
            item.classList.add('scroll-trigger--cancel');
            item.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'));
            item.querySelectorAll('img').forEach((image) => image.loading = 'lazy');
          }
          this.grid.append(...items);
          this.page = Number(nextPager.dataset.currentPage);
          this.nextUrl = nextPager.dataset.nextUrl;
          this.dataset.currentPage = String(this.page);
          this.dataset.nextUrl = this.nextUrl;
          this.pagesLoaded.add(url.href);
          const fallback = nextPager.querySelector('.pagination-wrapper');
          if (fallback) this.querySelector('.pagination-wrapper')?.replaceWith(fallback);
          this.button.hidden = !this.nextUrl;
          this.updateCount();
          succeeded = true;
        } catch (error) {
          if (error.name !== 'AbortError' && this.isConnected) {
            this.setAttribute('data-failed', '');
            this.status.textContent = this.dataset.errorLabel;
          }
        } finally {
          this.loading = false;
          this.button.disabled = false;
          this.removeAttribute('aria-busy');
          if (succeeded && this.nextUrl && this.isConnected) this.observer?.observe(this);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
